import { PaymentFrequency } from '../../models/config/payment-frequency.enum';
import { RegisteredItemProductDetails } from '../../models/registered-item/registered-item-product-details.interface';
import { mockRegisteredItemProductPaymentMethod } from './registered-item-product-payment-method.mock';

export const mockRegisteredItemProductDetails: RegisteredItemProductDetails = {
  paymentFrequency: PaymentFrequency.Monthly,
  paymentMethod: [mockRegisteredItemProductPaymentMethod],
  price: 5.31,
  warrantyProductName: 'Appliance Care Monthly IW/OOW',
  discountDetails: {
    discountedPrice: 2.66,
    discountAchCode: 'D50P3M',
    discountCcCode: 'D50P3M',
    discountedMonthsCount: 3,
    discountedMonthPercentage: 50,
  },
};
